import { render, staticRenderFns } from "./correl.vue?vue&type=template&id=73a8fa8e&scoped=true"
import script from "./correl.vue?vue&type=script&lang=js"
export * from "./correl.vue?vue&type=script&lang=js"
import style0 from "./correl.vue?vue&type=style&index=0&id=73a8fa8e&prod&lang=scss&scoped=true"
import style1 from "./correl.vue?vue&type=style&index=1&id=73a8fa8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a8fa8e",
  null
  
)

export default component.exports